// generated by genversion
export const version = '2.7.1';
//# sourceMappingURL=version.js.map